import { useState } from "react";
import "./assets/Technology.scss";

const Technology = (props) => {
    const [tech, setTech] = useState(props.tech[0]);
    
    const handleTech = (e) => {
        const child = e.target.parentNode.childNodes;
        for (let i = 0; i < child.length; i++){
            if ("navi-circle active" === child[i].className){
                child[i].classList.remove("active");
            }
        }
        console.log(e.target.className);
        e.target.classList.add("active");
        for (let i = 0; i < child.length; i++){
            if ("navi-circle active" === child[i].className){
                setTech(props.tech[i]);
            }
        }
    }

    return(

        <div id="tech">

            <section>
                <div>
                    <h3><span>03</span> Space Launch 101</h3>

                    <div className="toggle-navi">
                        
                        <div className="navi">
                            <div onClick={handleTech} className="navi-circle active">1</div>
                            <div onClick={handleTech} className="navi-circle">2</div>
                            <div onClick={handleTech} className="navi-circle">3</div>
                        </div>

                        <div>
                            <h4>The Terminology...</h4>
                            <h1>{tech.name}</h1>

                            <p>{tech.description}</p>
                        </div>
                    </div>
                </div>

                <div>
                    <img alt="vehicle" src={require(`${tech.images.portrait}`)}/>
                </div>
            </section>
        </div>
    );
}

export default Technology;